<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Choose a Fee Schedule</h4>
</div>
<div class="modal-body">
  <p>Choose a fee schedule to copy codes from:</p>
  <app-grid-wrapper
    #copyFromGrid
    [gridSize]="GridSize.small"
    (cellDoubleClicked)="copy()"
  ></app-grid-wrapper>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="copy()"
    [disabled]="!copyFromSelection || copyLoading"
  >
    OK
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
